<script setup lang="ts">
import { ComboboxSeparator, type ComboboxSeparatorProps } from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes, normalizeClass } from "vue";

const props = defineProps<ComboboxSeparatorProps & { class?: HTMLAttributes["class"] }>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ComboboxSeparator
		v-bind="delegatedProps"
		:class="twMerge('-mx-1 h-px bg-border', normalizeClass(props.class))"
	>
		<slot />
	</ComboboxSeparator>
</template>
